<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pr-3 pl-3">
            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                    <div class="breadcrumbnew">
                        <span>Requests</span>
                    </div>
                </div>
            </div>
            <div v-if="active_tab == 'history'" class="d-flex dis-none-ms mb-3 ml-6" style="flex-grow: 1">
                <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -20px !important">
                    <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                    <i v-if="search_history_requests !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                    <input ref="searchInput" v-model="search_history_requests" v-debounce:500ms="searchHistory" debounce-events="input" class="w-100 placeholder-text" type="text"
                        placeholder="Search by Lead Name"
                        style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                </div>
            </div>
            <div>
                <section class="d-flex justify-content-between">
                    <!-- <div class="d-flex">
                        <div class='slant-tabs' :class="{'activeTab':active_tab == 'requests','new-blue':active_tab == 'requests'}" @click="switchTabs('requests')">
                            <span class="text-capitalize">Requests</span>
                        </div>
                        <div class='slant-tabs' :class="{'activeTab':active_tab == 'history','new-blue':active_tab == 'history'}" @click="switchTabs('history')">
                            <span class="text-capitalize">History</span>
                        </div>
                    </div> -->
                    <!-- Tabs Section -->
                    <div class="tabs tabs-style-shape">
                        <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                            <defs>
                                <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                            </defs>
                        </svg>
                        <nav>
                            <ul class="ml-0">
                                <li :class="{'tab-current':active_tab == 'requests'}">
                                    <a href="javascript:;" @click="switchTabs('requests')" style="text-decoration: none !important;">
                                        <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                        <span>Requests</span>
                                    </a>
                                </li>
                                <li :class="{'tab-current':active_tab == 'history'}">
                                    <a href="javascript:;" @click="switchTabs('history')" style="text-decoration: none !important;">
                                        <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                        <span style="border-radius: 30px 0 0 0;">History</span>
                                    </a>
                                </li>
                                <!-- For styling we need this tag  -->
                                <li style="width: 0px !important;flex: 0 !important;">
                                    <a href="#section-shape-3" style="margin: 0">
                                        <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div v-if="active_tab == 'history'" class="d-flex dis-none" style="flex-grow: 1">
                        <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -20px !important">
                            <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                            <i v-if="search_history_requests !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                            <input ref="searchInput" v-model="search_history_requests" v-debounce:500ms="searchHistory" debounce-events="input" class="w-100 placeholder-text" type="text"
                                placeholder="Search by Lead Name"
                                style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                        </div>
                    </div>
                </section>
            </div>
            <!-- Request Tab -->
            <div v-if="active_tab == 'requests'" class="req-list bg-white">
                <div class="req-lis-header">
                    <p class="text-white pt-3 pb-3 pl-6 fw-500 fs-14">Request List</p>
                </div>
                <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                </div>
                <div v-else-if="!ajaxCallInProgress && pending_requests.length == 0" class="text-center">
                    <img src="/static/images/contact-list.png" width="350" height="250" class="pt-16"/>
                    <div class="text-center mt-10 fs-14 fw-500">No Requests found!</div>
                </div>
                <div v-else class="row pl-3 pr-3">
                    <div v-for="(pending, pending_index) in pending_requests" :key="pending_index" class="col-lg-4 col-md-4 col-sm-12 mt-4 mb-6 pl-4 pr-4">
                        <div class="p-6 req-card">
                            <h6 class="text-warning">Request to download Leads Excel data</h6>
                            <div class="d-flex justify-content-between align-items-center fw-500 text-muted">
                                <div class="text-capitalize">Lead Type - {{ pending.lead_type }}</div>
                                <div>Creation Date : {{ pending.created_time }}</div>
                            </div>
                            <hr>
                            <div class="leads-name">
                                <span class="text-color pt-2">{{ pending.created_by_name }} has requested to export Lead
                                    <span v-for="(lead_name, lead_name_index) in pending.lead_name" :key="lead_name_index">
                                        <span v-if="lead_name_index == 0 && lead_name != ''">{{ lead_name || "-" }}</span>
                                    </span>
                                    <span v-if="pending.lead_name.length > 1">
                                        <el-popover
                                            placement="bottom"
                                            width="auto"
                                            trigger="hover">
                                            <span v-for="(name, name_index) in pending.lead_name" :key="name_index">
                                                <span v-if="name" class="fw-500 custom_chips">{{name}}</span>
                                            </span>
                                            <el-button slot="reference" class="pl-0 pr-0 text-secondary fw-500 fs-14" style="padding: 0 !important; background: transparent;">
                                                +{{ pending.lead_count - 1 }} Leads
                                            </el-button>
                                        </el-popover>
                                    </span>
                                    in excel sheet.
                                </span>
                            </div>
                            <div class="mt-2">
                                <span class="fw-500">Message:</span>
                                <textarea-autosize class="digi-textarea white-background bordered message-box" style="max-height: 100px; min-height: 100px; word-break: break-word; overflow: overlay;"
                                    placeholder="Enter Message" maxlength="1000" v-model="pending.message" disabled/>
                            </div>
                            <div class="d-flex justify-content-center align-items-center mt-4">
                                <button class="btn new-cancel-button ml-2 mr-2" :disabled="diable_button" :class="{'dis-border':diable_button == true}" @click="rejectApproveRequest(pending, 'rejected')">Reject</button>
                                <button class="btn new-save-button ml-2 mr-2" :disabled="diable_button" @click="rejectApproveRequest(pending, 'approved')">Approve</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- History Tab -->
            <div v-if="active_tab == 'history'" class="req-list bg-white">
                <table class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th class="w-1">REQUESTED BY</th>
                            <th class="w-1">LEAD NAME'S REQUESTED</th>
                            <th class="w-1">LEAD TYPE</th>
                            <th class="w-1">REQUEST DATE</th>
                            <th class="w-1">STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajaxCallInProgress">
                            <td colspan="9">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && requests_history.length == 0" class="text-center font-weight-bold">
                            <td colspan="15">
                                <img src="/static/images/contact-list.png" width="350" height="250" class="pt-16"/>
                                <div class="text-center mt-10">No History found!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(history_data, history_data_index) in requests_history" :key="history_data_index">
                            <td class="text-capitalize">{{ history_data.created_by_name}}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[0]">{{history_data.lead_count ? history_data.lead_name[0] : "-"}}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[1]" v-if="history_data.lead_name[0] == ''">{{ history_data.lead_name[1] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[2]" v-else-if="history_data.lead_name[1] == ''">{{ history_data.lead_name[2] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[3]" v-else-if="history_data.lead_name[2] == ''">{{ history_data.lead_name[3] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[4]" v-else-if="history_data.lead_name[3] == ''">{{ history_data.lead_name[4] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[5]" v-else-if="history_data.lead_name[4] == ''">{{ history_data.lead_name[5] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[6]" v-else-if="history_data.lead_name[5] == ''">{{ history_data.lead_name[6] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[7]" v-else-if="history_data.lead_name[6] == ''">{{ history_data.lead_name[7] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[8]" v-else-if="history_data.lead_name[7] == ''">{{ history_data.lead_name[8] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[9]" v-else-if="history_data.lead_name[8] == ''">{{ history_data.lead_name[9] }}</span>
                                    <span class="text-truncate cust-max-width" :title="history_data.lead_name[10]" v-else-if="history_data.lead_name[9] == ''">{{ history_data.lead_name[10] }}</span>
                                    <el-popover
                                        v-if="history_data.lead_name.length > 1"
                                        placement="bottom"
                                        width="auto"
                                        trigger="hover">
                                        <span v-for="(name,name_index) in history_data.lead_name" :key="name_index">
                                            <span v-if="name" class="fw-500 custom_chips">{{name}}</span>
                                        </span>
                                        <el-button slot="reference" class="pl-0 pr-0">
                                            <div class="fw-500 mt-4px text-center text-secondary">
                                                +{{history_data.lead_count - 1}} more
                                            </div>
                                        </el-button>
                                    </el-popover>
                                </div>
                            </td>
                            <td class="text-capitalize">{{ history_data.lead_type || "-"}}</td>
                            <td>{{ history_data.created_time}}</td>
                            <td>
                                <button style="text-transform: capitalize; width: 110px !important;" class="btn btn-smm text-white btn-default btn-width"
                                    :class="{
                                    'btn-approved':history_data.request_status == 'approved',
                                    'btn-rejected':history_data.request_status == 'rejected'}">
                                        {{ history_data.request_status[0].toUpperCase() + history_data.request_status.substring(1) }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- Pagination Section -->
                <div v-if="requests_history.length != 0 && !ajaxCallInProgress" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                    <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                        :options="pageLimit" :close-on-select="true" v-model="limit" :max-height="210" @close="loadRequestsHistoryData()"
                        open-direction="top" :show-labels="false" placeholder="" :allow-empty="false" :searchable="false"
                        style="width: 4.2em !important;padding-right: 10px!important;">
                    </multiselect>
                    <span class="page-info pr-2 pl-2 fw-500 fw-500 fs-14 font-size-small">Per page</span>
                    <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <i class="icon-chevron-double-left"></i>
                        </el-tooltip>
                    </button>
                    <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <i class="icon icon-chevron-left"></i>
                        </el-tooltip>
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                    <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <i class="icon icon-chevron-right"></i>
                        </el-tooltip>
                    </button>
                    <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <i class="icon-chevron-double-right"></i>
                        </el-tooltip>
                    </button>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <reject-request v-if="openRejectPopUp" modal_name="rejectRequest" @rejectRequests="rejectRequests" @cancelReject="closeReject"></reject-request>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import requests from "../mixins/requests"
import { SweetModal } from 'sweet-modal-vue';
import RejectRequest from "./RejectRequest";
export default {
    data(){
        return{
            message: [],
            active_tab: 'requests',
            search_history_requests: '',
            id: '',
            status: '',
            requests: false,
            history: false,
            ajaxCallInProgress: false,
            pending_requests: [],
            requests_history: [],
            success_msg:"",
            warning_msg:"",
            temp_total: 0,
            skip: 0,
            limit: 10,
            skip_temp: 0,
            total: 0,
            pageLimit: [],
            diable_button: false,
            openRejectPopUp: false,
        }
    },
    components: {
        HalfCircleSpinner,
        SweetModal,
        RejectRequest,
    },
    mixins:[requests],
    methods:{
        clearSearch(){
            this.search_history_requests = "";
            this.$refs.searchInput.focus();
            this.loadRequestsHistoryData();
        },
        //Pagination methods
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.loadRequestsHistoryData()
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.loadRequestsHistoryData()
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.loadRequestsHistoryData()
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.loadRequestsHistoryData()
        },
        //API call to reject a request
        async rejectApproveRequest(request, status){
            try{
                this.diable_button = true;
                this.status = status
                this.id = request.id
                if(status == 'approved'){
                    let params ={
                        request_status: this.status,
                        message: request.message,

                    }
                    let response = await this.getRejectApproveRequestAPI(params, this.id)
                    if (response.status_id == 1) {
                        this.success_msg = response.message
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.loadPendingRequests();
                            this.$refs.success_modal.close();
                            this.diable_button = false;
                        }, 3000);
                    } else {
                        this.warning_msg = response.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                            this.diable_button = false;
                        }, 3000);
                    }
                } else if(status == 'rejected'){
                    this.openRejectPopUp = true;
                    setTimeout(()=>{
                        this.$modal.show("rejectRequest")
                    },500)
                }
            } catch(error) {
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.diable_button = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //API call to reject a request
        async rejectRequests(reason){
            let params ={
                request_status: this.status,
                message: reason,

            }
            let response = await this.getRejectApproveRequestAPI(params, this.id)
            if (response.status_id == 1) {
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.loadPendingRequests();
                    this.$refs.success_modal.close();
                }, 3000);
            } else {
                this.warning_msg = response.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            this.closeReject();
        },
        closeReject(){
            this.openRejectPopUp = false;
            this.diable_button = false;
        },
        //Used to switch tabs
        switchTabs(type){
            if(type == 'requests'){
                this.active_tab = 'requests'
                this.requests = true
                this.history = false
                this.loadPendingRequests();
            } else if(type == 'history') {
                this.search_history_requests = ''
                this.skip = 0;
                this.limit = 10;
                this.active_tab = 'history'
                this.requests = false
                this.history = true
                this.loadRequestsHistoryData();
            }
        },
        //API call to get requests history data searched
        async searchHistory(){
            this.ajaxCallInProgress = true
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: this.search_history_requests,
                }
                let response = await this.getRequestsHistoryData(params)
                this.requests_history = response.Data
                this.total = response.total_count
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        //API call to get pending requests data
        async loadPendingRequests(){
            this.ajaxCallInProgress = true
            try {
                let response = await this.getDownloadLeadsPendingRequests()
                this.pending_requests = response.Data
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
        //API call to get requests history data
        async loadRequestsHistoryData(){
            this.ajaxCallInProgress = true
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: "",
                }
                let response = await this.getRequestsHistoryData(params)
                this.requests_history = response.Data
                this.total = response.total_count
            }
            catch (error) {
            }
            this.ajaxCallInProgress = false
        },
    },
    mounted() {
        this.loadPendingRequests();
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    }
}
</script>
<style scoped>
    .req-list{
        min-height: 500px;
        border-radius: 0px 8px 8px 8px;
        padding-top: 20px;
        overflow: auto;
    }
    .req-lis-header{
        background-color: #00448b;
        border-radius: 8px;
    }
    .reject-button{
        color: #1C61C2;
        border: 1px solid #1C61C2;
        background: #fff;
        width: 120px;
    }
    .approve-button{
        color: #fff;
        background: #1C61C2;
        width: 120px;
    }
    .req-card{
        box-shadow: rgb(205 210 218) 0px 4px 8px;
        border-radius: 4px;
        max-height: 390px;
        min-height: 390px
    }
    .message-box{
        height: 10em;
        overflow: auto;
    }
    .text-color{
        color: #0D84F2;
    }
    .slant-tabs{
        height: 43px;
    }
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 12px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .btn-approved{
        background: #078A63 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-rejected{
        background: #E64646 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .custom_chips{
        display: inline-flex;
        padding: 3px 12px;
        background: #dfe8f4;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 12.5px;
        cursor: pointer;
        color: #4e5764;
    }
    .leads-name{
        min-height: 100px;
        max-height: 100px;
    }
    .cust-max-width{
        max-width: 350px;
    }
    .dis-border{
        border: 1px solid transparent !important;
    }
    .dis-border:hover{
        color: rgb(133, 133, 133, 0.6) !important;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    @media only screen and (max-width: 540px) {
        .dis-none{
            display: none !important;
        }
    }
    @media only screen and (min-width: 541px) {
        .dis-none-ms{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Requests/Requests.vue